import { render, staticRenderFns } from "./PluginEditPanel.vue?vue&type=template&id=631be3b0&scoped=true"
import script from "./PluginEditPanel.vue?vue&type=script&lang=ts"
export * from "./PluginEditPanel.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./PluginEditPanel.vue?vue&type=style&index=0&id=631be3b0&prod&scoped=true&lang=less")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "631be3b0",
  null
  ,true
)

export default component.exports